
import { Outlet } from "react-router-dom"
import { useState, useEffect } from "react";
import ScrollToTop from "../../functions/scrolltoTop";

import Header from './Header'
import Footer from './Footer'

export default function Layout() {
    const [darkMode, setDarkMode] = useState(false);

    function switchColorScheme() {
        setDarkMode((prev) => {
            const newMode =!prev;
            localStorage.setItem("dark-mode", JSON.stringify(newMode));
            return newMode
        });
    }

    useEffect(()=>{
        const currentColorScheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? true : false;
        const localStorageMode = window.localStorage.getItem('dark-mode')

        if (localStorageMode) {
            setDarkMode(JSON.parse(localStorageMode))
        } else {
            setDarkMode(currentColorScheme)
        }
    },[])

    return(
        <div className={`site-wrapper ${darkMode ? "dark" : "light"}`}>
            <Header 
                switchColorScheme={switchColorScheme} 
                darkMode={darkMode}
                setDarkMode={setDarkMode}    
            />
            <ScrollToTop />
            <Outlet />
            <Footer />
        </div>
    )
}